import { render, staticRenderFns } from "./StoreLogin.vue?vue&type=template&id=482e4bc8&scoped=true&"
import script from "./StoreLogin.vue?vue&type=script&lang=js&"
export * from "./StoreLogin.vue?vue&type=script&lang=js&"
import style0 from "./StoreLogin.vue?vue&type=style&index=0&id=482e4bc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e4bc8",
  null
  
)

export default component.exports